import { Box, Checkbox, FormControlLabel, FormHelperText } from '@mui/material';
import { useController } from 'react-hook-form';

import { FormElementProps } from '@/components/form/types';

interface FormCheckboxProps extends Omit<FormElementProps, 'label'> {
    formControlLabelProps?: Record<string, unknown>;
    checkboxProps?: Record<string, unknown>;
    label: React.ReactNode;
}

export const FormCheckbox = ({
    name,
    control,
    label,
    formControlLabelProps = {},
    controllerProps = {},
    checkboxProps = {},
}: FormCheckboxProps) => {
    const { field, fieldState } = useController({
        name,
        control,
        ...controllerProps,
    });
    return (
        <Box>
            <FormControlLabel
                label={label}
                {...formControlLabelProps}
                control={<Checkbox {...field} checked={!!field.value} {...checkboxProps} />}
            />
            {fieldState.error && <FormHelperText error>{fieldState.error?.message}</FormHelperText>}
        </Box>
    );
};
